/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DevRobotIcon20Light = forwardRef('DevRobotIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M13 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" }),
        React.createElement("path", { d: "M7 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 2.396a1.25 1.25 0 1 0-1 0V4H6.5A3.5 3.5 0 0 0 3 7.5V9H.5a.5.5 0 0 0 0 1H3v3.5A3.5 3.5 0 0 0 6.5 17h6a3.5 3.5 0 0 0 3.5-3.5V10h2.5a.5.5 0 0 0 0-1H16V7.5A3.5 3.5 0 0 0 12.5 4H10V2.396ZM15 7.5A2.5 2.5 0 0 0 12.5 5h-6A2.5 2.5 0 0 0 4 7.5v6A2.5 2.5 0 0 0 6.5 16h6a2.5 2.5 0 0 0 2.5-2.5v-6Z" })));
});
